module.exports = __webpack_public_path__ + "static/img/case-1caoyuan.8f2566d8.jpg";